import { Button } from "@mui/material";
import { useEffect, useState } from "react";
import Popup from "elements/Popup";
import { ApiRequest } from "GlobalFunctions";
import EmailIcon from '@mui/icons-material/Email';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';

const defaultData: any = {};

export default function MessagesViewer(props: any) {
  const { open, setOpen, message_id, loadList } = props;

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(defaultData);

  useEffect(() => {
    if (open && message_id !== null) {
      setLoading(true);

      ApiRequest({
        url: "/messages/details",
        method: "get",
        headers: { ltkn: localStorage.getItem("ltkn") },
        query: { message_id },
        setResponse: (response: any) => {
          if (response.status === "success") {
            setData(response.data);

            // Mark as read if not already
            if (!response.data.is_read) {
              ApiRequest({
                url: "/messages/markAsRead",
                method: "post",
                headers: { ltkn: localStorage.getItem("ltkn") },
                body: { message_id },
                setResponse: () => {
                  loadList && loadList();
                },
              });
            }
          }
          setLoading(false);
        },
      });
    }
  }, [open, message_id]);

  return (
    <Popup
      open={open}
      onClose={() => {
        setOpen(false);
        setData(defaultData);
      }}
      loading={loading}
    >
      <div className="DialogContainer" style={{ minWidth: "500px" }}>
        <div className="ModuleWrapper">
          <div className="boxContainerHeader">
            <div className="boxContainerTitle">
              <h2 className="h2_title">{data.title}</h2>
              <span className="h2_subtitle">
                De: <strong>{data.user_name}</strong> &nbsp;·&nbsp;{" "}
                {data.created_at &&
                  new Date(data.created_at).toLocaleString("es-ES", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true,
                  })}
              </span>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              {data.is_read ? (
                <MarkEmailReadIcon sx={{ color: "#0BA757" }} titleAccess="Leído" />
              ) : (
                <EmailIcon sx={{ color: "#cccccc" }} titleAccess="No leído" />
              )}
            </div>
          </div>

          <p style={{ marginTop: "16px", whiteSpace: "pre-wrap" }}>{data.body}</p>
        </div>
      </div>

      <div className="dialogButtons">
        <Button
          onClick={() => {
            setOpen(false);
            setData(defaultData);
          }}
          variant="outlined"
          className="button_2"
        >
          Cerrar
        </Button>
      </div>
    </Popup>
  );
}
